export const TAB_NAMES = {
    DRUG: 'drug',
    DISEASE: 'disease',
    TEACHING: 'teaching',
};
